/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useFloodgateFeature } from "hooks/useFloodgateFeature";

export const PODCAST_PREMIUM_OFFER_ID = "0CE62375A31494AA5908869C617C98AA";
export const FIREFLY_PRO_OFFER_ID = "5FEBA265B427FE3C8AD6FB1DFD078402";

// Adobe Commerce/AOS offer ID for the current Premium/Pro plan, switched by
// the podcast_sku_migration_enabled Floodgate flag. Shared by usePremiumPricing
// (display price) and useCheckout (purchase) so they always quote and charge
// the same SKU. Returns null until the flag has resolved, since defaulting to
// either SKU before then risks quoting or charging the wrong one.
export const useOfferId = (): string | null => {
  const isFireflyPro = useFloodgateFeature("podcast_sku_migration_enabled");

  if (isFireflyPro === null) {
    return null;
  }

  return isFireflyPro ? FIREFLY_PRO_OFFER_ID : PODCAST_PREMIUM_OFFER_ID;
};
